/**
 * Pull the human-readable message off a thrown `PlaybookApiError` envelope
 * (`{ code, message }`), falling back when the error isn't an API error. Lets
 * write flows surface the server's reason — e.g. the activation precondition —
 * without importing the error class.
 */
export function errorMessage(err: unknown, fallback: string): string {
  const envelope = (err as { envelope?: { message?: string } })?.envelope;
  return envelope?.message ?? fallback;
}
